import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div>
        <img width="100%" height="400px;" src="images/cross.png" alt="" />
        <div style={{textAlign: "center"}}>
          <a href="/chart">참가자</a>
          <br />
          <br />
          <br />
          연락처: <a href="mailto:pray4korea@yahoo.com">pray4korea@yahoo.com</a>
        </div>
      </div>
    );
  }
}
